import { backgroundColor, mainColor } from "./mainstyle";
// import { textStyle } from "./textstyle";

export const buttonStyle = {
  // ...textStyle,
  bgcolor: backgroundColor,
  hoverBg: "#5FB3FF",
};
